import React from 'react';
import { createComponent } from "../../../wayin-react";
import { positions, sizes } from "../../../enums";
import Layout from "../layout";
import LoadingState from "../../abstractions/loading-state";
/**
 * displays a 'loading' view of the uploader, useful while loading in asset ref information
 */

var FileLoadingView = createComponent({
  displayName: 'FileLoadingView',
  render: function render() {
    return /*#__PURE__*/React.createElement("div", {
      className: "upload-view"
    }, /*#__PURE__*/React.createElement(Layout, {
      isFluidHeight: true,
      columnStyles: {
        verticalAlign: positions.verticalAlign.MIDDLE
      }
    }, /*#__PURE__*/React.createElement(LoadingState, {
      spinnerSize: sizes.M
    })));
  }
});
export default FileLoadingView;
//# sourceMappingURL=file-loading.js.map